import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './IdentifyTravelersLazyLoadedContent.css';
import React, { useEffect, useRef, useState } from 'react';
import BottomRecommendationPanel from '../BottomRecommendationPanel/BottomRecommendationPanel';
import WizardModal from '../atoms/WizardModal/WizardModal';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import TravelPlan from '../TravelPlan/TravelPlan';
import JourneyStep from '../JourneyStep/JourneyStep';
import InterestsStep from '../InterestsStep/InterestsStep';
import BudgetStep from '../BudgetStep/BudgetStep';
import EmailStep from '../EmailStep/EmailStep';
import { get, getFormatedDateForAnalytics, monthList } from '../../utils';
import { createMapFromDictionary } from '../../utils/createMapFromDictionary';
import { useCollectedData } from './useCollectedData';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import { WizardBottomPanel } from '../atoms/WizardBottomPanel/WizardBottomPanel';
import { WizardInfoMessage } from '../atoms/WizardInfoMessage/WizardInfoMessage';
import { SHA256 } from '../../utils/sha256';
import { IDENTIFY_TRAVELERS_CLOSE_EXPIRED } from './IdentifyTravelers';
import { generateQueryFromArray } from '../../utils/generateQueryFromArray';
import { MILLISECONDS_IN_DAY } from './constants';
import Recaptcha from '../Login/components/Recaptcha';
var createMapFromItemsDict = function createMapFromItemsDict(choiceItemsDict) {
  var map = new Map();
  choiceItemsDict.forEach(function (el) {
    map.set(el.taxonomy.targetItem.title.value, {
      icon: el.iconCode.value
    });
  });
  return map;
};
var getEventDatesRangeQueryParam = function getEventDatesRangeQueryParam(from, to) {
  var userTimezoneOffset1 = from.getTimezoneOffset() * 60000;
  return "(datesRange.to > ".concat(Math.round((from.getTime() - userTimezoneOffset1) / 1000), " AND datesRange.from < ").concat(Math.round((to.getTime() - userTimezoneOffset1) / 1000), ")");
};
var getFirstAndLastDateOfMonth = function getFirstAndLastDateOfMonth(monthNumber) {
  var date = new Date();
  if (monthNumber < date.getMonth() + 1) {
    date.setFullYear(date.getFullYear() + 1);
  }
  var firstDate = new Date(date);
  firstDate.setMonth(monthNumber - 1);
  if (monthNumber !== date.getMonth() + 1) {
    firstDate.setDate(1);
  }
  firstDate.setHours(0, 0, 0, 0);
  var lastDate = new Date(date);
  lastDate.setMonth(monthNumber);
  lastDate.setDate(1);
  lastDate.setHours(0, 0, 0, 0);
  lastDate = new Date(lastDate.getTime() - MILLISECONDS_IN_DAY);
  return [firstDate, lastDate];
};
var IdentifyTravelersLazyLoadedContent = function IdentifyTravelersLazyLoadedContent(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    rendering = _ref.rendering;
  var recommendationsTitle = get(fields, "data.configuration.recommendationsTitle.jss.value", "");
  var recommendations = get(fields, "data.configuration.recommendations.targetItems", []);
  var dictionary = get(fields, "data.dictionary.dictionaryValues", []);
  var forecastValues = get(fields, "data.weatherForecast.forecastValues", []);
  var choiceItemsDict = get(fields, "data.taxonomyMappings.dictionaryValues", []);
  var choiceItems = get(fields, "data.configuration.travelerTypes.targetItem.tagsToDisplay.values", []);
  var doDoList = get(fields, "data.configuration.thingsToDo.targetItem.tagsToDisplay.values", []);
  var budgetList = get(fields, "data.configuration.budget.targetItem.tagsToDisplay.values", []);
  var privacyNotice = get(fields, "data.configuration.privacyNotice.jss.value", "");
  var mandatoryJourneyStep = get(fields, "data.configuration.mandatoryJourneyStep.jss.value", false);
  var appearanceDelay = Number(get(fields, "data.configuration.appearanceDelay.value", 5000));
  var travelerTypesFieldName = get(fields, "data.configuration.travelerTypes.targetItem.fieldNameItem.item.fieldName.value", "category");
  var budgetFieldName = get(fields, "data.configuration.budget.targetItem.fieldNameItem.item.fieldName.value", "category");
  var thingsToDoFieldName = get(fields, "data.configuration.thingsToDo.targetItem.fieldNameItem.item.fieldName.value", "category");
  var recommendationLink = get(fields, "data.configuration.recommendationLink.jss.value.href", "");
  var titleSvg = get(fields, "data.configuration.recommendationIconCode.value", "");
  var uid = get(rendering, "uid", "");
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var _useCollectedData = useCollectedData(),
    collectedData = _useCollectedData.collectedData,
    setBudgetStepData = _useCollectedData.setBudgetStepData,
    setEmailStepData = _useCollectedData.setEmailStepData,
    setInterestsStepData = _useCollectedData.setInterestsStepData,
    setJourneyStepData = _useCollectedData.setJourneyStepData,
    setTravelDateData = _useCollectedData.setTravelDateData;
  var mapDictionary = createMapFromDictionary(dictionary);
  var choiceItemsDictMap = createMapFromItemsDict(choiceItemsDict);
  var recaptchErrorMessage = mapDictionary.get("FieldErrorRequiredRecaptcha") || "";
  var widgetMainTitle = mapDictionary.get("WidgetMainTitle");
  var steps = ["DatesStepName", "JourneyStepName", "InterestsStepName", "BudgetStepName", "EmailStepName"].map(function (el) {
    return mapDictionary.get(el) || "";
  });
  var analyticsStepsDict = ["dates", "journey", "interests", "budget", "email"];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var language = sitecoreContext && sitecoreContext.language || 'en';
  var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'replaceGlobal';
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    recaptchaError = _React$useState2[0],
    setRecaptchaError = _React$useState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPanelOpened = _useState2[0],
    setIsPanelOpened = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isWizardOpened = _useState4[0],
    setIsWizardOpened = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentStep = _useState6[0],
    setCurrentStep = _useState6[1];
  var recaptchaRef = useRef(null);
  var isTravelDateValid = collectedData.travelDate.notSure ? !!collectedData.travelDate.selectedMonth : !!collectedData.travelDate.period.length;
  var hidePanel = function hidePanel() {
    localStorage.setItem(IDENTIFY_TRAVELERS_CLOSE_EXPIRED, String(Date.now() + MILLISECONDS_IN_DAY));
    setIsPanelOpened(false);
  };
  var openWizard = function openWizard() {
    setIsWizardOpened(true);
    hidePanel();
  };
  var hideWizard = function hideWizard() {
    setIsWizardOpened(false);
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerCloseIconAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep]]);
  };
  var onBackClickAnalytics = function onBackClickAnalytics() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerButtonClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "back"]);
  };
  var goBack = function goBack() {
    setCurrentStep(currentStep - 1);
  };
  var goNext = function goNext() {
    setCurrentStep(currentStep + 1);
  };
  var generateQuery = function generateQuery() {
    var params = [[travelerTypesFieldName, collectedData.journeyStepData.choice], [budgetFieldName, collectedData.budgetStepData.choice], [thingsToDoFieldName, collectedData.interestsStepData.selectedIds]];
    if (collectedData.travelDate.notSure) {
      params.push(["datesRange", getEventDatesRangeQueryParam.apply(void 0, _toConsumableArray(getFirstAndLastDateOfMonth(Number(collectedData.travelDate.selectedMonth))))]);
    } else if (collectedData.travelDate.period && collectedData.travelDate.period[0] && collectedData.travelDate.period[1]) {
      params.push(["datesRange", getEventDatesRangeQueryParam(collectedData.travelDate.period[0], collectedData.travelDate.period[1])]);
    }
    return generateQueryFromArray(params);
  };
  var getRecomendationLink = function getRecomendationLink() {
    return "".concat(recommendationLink, "?").concat(generateQuery());
  };
  var sendData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var startDate, endDate, userTimezoneOffset, travelStartDate, travelEndDate, recaptchaToken, dataToSalesforce;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            startDate = collectedData.travelDate.period[0];
            endDate = collectedData.travelDate.period[1];
            userTimezoneOffset = startDate && startDate.getTimezoneOffset() * 60000;
            travelStartDate = startDate && new Date(startDate.getTime() - userTimezoneOffset).toJSON() || null;
            travelEndDate = endDate && new Date(endDate.getTime() - userTimezoneOffset).toJSON();
            if (!recaptchaRef.current) {
              _context.next = 9;
              break;
            }
            _context.next = 8;
            return recaptchaRef.current.getRecaptchaToken();
          case 8:
            recaptchaToken = _context.sent;
          case 9:
            if (!recaptchaToken) {
              setRecaptchaError(recaptchErrorMessage);
            } else {
              setRecaptchaError('');
            }
            dataToSalesforce = {
              emailAddress: collectedData.emailStepData.email,
              travelStartDate: travelStartDate,
              travelEndDate: travelEndDate || travelStartDate,
              travelMonth: collectedData.travelDate.selectedMonth ? Number(collectedData.travelDate.selectedMonth) : null,
              travelPeriod: collectedData.travelDate.selectedMonth ? collectedData.travelDate.dayCount : null,
              typeOfTraveler: collectedData.journeyStepData.choice,
              travelingBudget: collectedData.budgetStepData.choice,
              travelingInterest: collectedData.interestsStepData.selectedIds,
              consent: collectedData.emailStepData.receiveOffers,
              recommendationPageUrl: "".concat(window.location.origin).concat(getRecomendationLink()),
              language: language,
              "grecaptcharesponse": recaptchaToken
            };
            _context.next = 13;
            return fetch("".concat(apiGlobal, "/api/Recommendation/Share"), {
              method: 'POST',
              body: JSON.stringify(dataToSalesforce),
              redirect: 'follow',
              headers: {
                'Content-Type': 'application/json'
              }
            }).catch(function (err) {
              return console.error(err);
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function sendData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var datesNextAnalytics = function datesNextAnalytics() {
    if (collectedData.travelDate.period.length) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerSubmitCalendarNalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], getFormatedDateForAnalytics(collectedData.travelDate.period[0]), getFormatedDateForAnalytics(collectedData.travelDate.period[1]), "next"]);
    } else {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerDaysSubmitClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], collectedData.travelDate.dayCount.toString(), monthList[Number(collectedData.travelDate.selectedMonth) - 1], "next"]);
    }
  };
  var journeyNextAnalytics = function journeyNextAnalytics() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerTravelerTypeSubmitClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], collectedData.journeyStepData.choice, "next"]);
  };
  var skipAnalytics = function skipAnalytics() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerButtonClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "skip"]);
  };
  var trackPanelOpened = function trackPanelOpened() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["ContextualHelperOpenAnalytics"], params));
  };
  var onPanelHide = function onPanelHide(isIconClick) {
    hidePanel();
    if (isIconClick) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["ContextualHelperCloseIconAnalytics"], params));
    } else {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["ContextualHelperCloseAnalytics"], params));
    }
  };
  var onPanelItemClick = function onPanelItemClick(isWidgetLink, itemName) {
    if (isWidgetLink) {
      openWizard();
    }
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["ContextualHelperLookingForAnalytics"], params), itemName);
  };
  var onDateChange = function onDateChange(dates) {
    var _dates = _slicedToArray(dates, 2),
      from = _dates[0],
      to = _dates[1];
    if (to) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerFromToAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "to", getFormatedDateForAnalytics(to)]);
    } else if (from) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerFromToAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "from", getFormatedDateForAnalytics(from)]);
    }
  };
  var onNotSureToggle = function onNotSureToggle(value) {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerNotSureSwitcherAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "not sure of my travel dates", value ? "on" : "off"]);
  };
  var onMonthClick = function onMonthClick(monthId) {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerMonthClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], monthList[Number(monthId) - 1]]);
  };
  var onCounterChange = function onCounterChange(value) {
    if (collectedData.travelDate.selectedMonth) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerDaysClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], value.toString(), monthList[Number(collectedData.travelDate.selectedMonth) - 1]]);
    } else {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerDaysClickAnalyticsWithoutMonth"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], value.toString()]);
    }
  };
  var onJourneyStepChoiceChange = function onJourneyStepChoiceChange(value) {
    setJourneyStepData(value);
    if (value.choice) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerTravelerTypeClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], value.choice]);
    }
  };
  var onInterestsChoiceChange = function onInterestsChoiceChange(data) {
    setInterestsStepData(data);
    if (data.selectedIds.length) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerThingsToDoClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], data.selectedIds.join(",")]);
    }
  };
  var interestsNextAnalytics = function interestsNextAnalytics() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerThingsToDoSubmitClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], collectedData.interestsStepData.selectedIds.join(","), "next"]);
  };
  var onBudgetChoiceChange = function onBudgetChoiceChange(value) {
    setBudgetStepData(value);
    if (value.choice) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerBudgetClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], value.choice]);
    }
  };
  var budgetNextAnalytics = function budgetNextAnalytics() {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerThingsToDoSubmitClickAnalytics"], params), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], collectedData.budgetStepData.choice, "next"]);
  };
  var onEmailStepDataChange = function onEmailStepDataChange(value) {
    setEmailStepData(value);
  };
  var onReceiveOffersCheck = function onReceiveOffersCheck(value) {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerPopupIdentifierClickAnalytics"], params), [uid, value ? "check" : "uncheck"]);
  };
  var onDataSend = function onDataSend() {
    sendData();
    setIsWizardOpened(false);
    localStorage.setItem(IDENTIFY_TRAVELERS_CLOSE_EXPIRED, String(Date.now() + MILLISECONDS_IN_DAY * 30));
    tealiumClickFunc(_objectSpread(_objectSpread({}, tealiumMergeClickNewData(eventsAnalytics["TripPlannerPopupIdentifierEmailSubmitAnalytics"], params)), {}, {
      email: SHA256(collectedData.emailStepData.email)
    }), ["".concat(currentStep + 1), analyticsStepsDict[currentStep], "surprise me"]);
    if (collectedData.emailStepData.receiveOffers) {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics["TripPlannerPopupIdentifierEmailSuccessAnalytics"], params), uid);
    }
  };
  useEffect(function () {
    var timeout = setTimeout(function () {
      setIsPanelOpened(true);
      trackPanelOpened();
    }, appearanceDelay * 1000);
    return function () {
      return clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appearanceDelay]);
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, isPanelOpened && /*#__PURE__*/React.createElement(BottomRecommendationPanel, {
    hide: onPanelHide,
    items: recommendations.map(function (el) {
      return {
        id: el.id,
        svgIcon: el.recommendationIconCode.value,
        text: el.title.jss.value,
        href: el.isWidgetLink.jss.value ? undefined : el.link.jss.value.href,
        onClick: function onClick() {
          return onPanelItemClick(el.isWidgetLink.jss.value, el.name);
        },
        highlighted: el.isWidgetLink.jss.value
      };
    }),
    title: recommendationsTitle,
    titleSvg: titleSvg
  }), isWizardOpened && /*#__PURE__*/React.createElement(WizardModal, {
    currentStepId: currentStep,
    hide: hideWizard,
    rtl: rtl,
    steps: steps,
    title: sitecoreContext.configuration.country ? widgetMainTitle && widgetMainTitle.replace('{x}', sitecoreContext.configuration.country) || '' : ''
  }, currentStep === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wizard-content"
  }, /*#__PURE__*/React.createElement(TravelPlan, {
    initData: collectedData.travelDate,
    onDataChange: setTravelDateData,
    onDateChange: onDateChange,
    dayCountTitle: mapDictionary.get('DatesStepDuration') || '',
    countDayTemplate: mapDictionary.get('DatesStepDay') || '',
    countDaysTemplate: mapDictionary.get('DatesStepDays') || '',
    fahrenheitLabel: mapDictionary.get('fahrenheit') || '',
    celsiusLabel: mapDictionary.get('celsius') || '',
    months: forecastValues.map(function (el) {
      return {
        id: el.monthNaumber.value,
        monthName: el.monthName.value,
        temperature: Number(el.averageDayTemperature.value),
        weatherIcon: el.iconCode.value
      };
    }),
    chooseMonthTitle: mapDictionary.get('DatesStepCalendarTitle') || '',
    helpMessage: mapDictionary.get('DatesStepDescription') || '',
    title: mapDictionary.get('DatesStepTitle') || '',
    notSureLabel: mapDictionary.get('DatesStepToggle') || '',
    onNotSureToggle: onNotSureToggle,
    onMonthClick: onMonthClick,
    onCounterChange: onCounterChange
  })), /*#__PURE__*/React.createElement(WizardBottomPanel, {
    rtl: rtl,
    backLabel: mapDictionary.get('Back') || '',
    nextLabel: mapDictionary.get(isTravelDateValid ? 'Next' : 'Skip') || '',
    onBackClick: function onBackClick() {
      hideWizard();
      onBackClickAnalytics();
    },
    onNextClick: function onNextClick() {
      goNext();
      isTravelDateValid ? datesNextAnalytics() : skipAnalytics();
    }
  })), currentStep === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wizard-content"
  }, /*#__PURE__*/React.createElement(JourneyStep, {
    initData: collectedData.journeyStepData,
    onDataChange: onJourneyStepChoiceChange,
    title: mapDictionary.get('JourneyStepTitle') || '',
    description: mapDictionary.get('JourneyStepDescription') || '',
    choiceItems: choiceItems.map(function (el) {
      var choiceItem = choiceItemsDictMap.get(el.title.value);
      return {
        id: el.title.value,
        svgIcon: choiceItem ? choiceItem.icon : '',
        name: el.title.value
      };
    })
  })), !mandatoryJourneyStep && /*#__PURE__*/React.createElement(WizardInfoMessage, {
    infoMessage: mapDictionary.get('OptionalText') || ''
  }), /*#__PURE__*/React.createElement(WizardBottomPanel, {
    rtl: rtl,
    backLabel: mapDictionary.get('Back') || '',
    nextLabel: mapDictionary.get(!mandatoryJourneyStep && !collectedData.journeyStepData.choice ? 'Skip' : 'Next') || '',
    onBackClick: function onBackClick() {
      goBack();
      onBackClickAnalytics();
    },
    onNextClick: function onNextClick() {
      goNext();
      !mandatoryJourneyStep && !collectedData.journeyStepData.choice ? skipAnalytics() : journeyNextAnalytics();
    },
    isNextDisabled: mandatoryJourneyStep && !collectedData.journeyStepData.choice
  })), currentStep === 2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wizard-content"
  }, /*#__PURE__*/React.createElement(InterestsStep, {
    initData: collectedData.interestsStepData,
    onDataChange: onInterestsChoiceChange,
    title: mapDictionary.get('InterestsStepTitle') || '',
    choiceItems: doDoList.map(function (el) {
      return {
        id: el.title.value,
        text: el.title.value
      };
    }),
    description: mapDictionary.get('InterestsStepDescription') || ''
  })), /*#__PURE__*/React.createElement(WizardBottomPanel, {
    rtl: rtl,
    backLabel: mapDictionary.get('Back') || '',
    nextLabel: mapDictionary.get('Next') || '',
    onBackClick: function onBackClick() {
      goBack();
      onBackClickAnalytics();
    },
    onNextClick: function onNextClick() {
      goNext();
      interestsNextAnalytics();
    },
    isNextDisabled: !collectedData.interestsStepData.selectedIds.length
  })), currentStep === 3 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wizard-content"
  }, /*#__PURE__*/React.createElement(BudgetStep, {
    initData: collectedData.budgetStepData,
    title: mapDictionary.get('BudgetStepTitle') || '',
    choiceItems: budgetList.map(function (el) {
      var choiceItem = choiceItemsDictMap.get(el.title.value);
      return {
        id: el.title.value,
        name: el.title.value,
        svgIcon: choiceItem ? choiceItem.icon : ''
      };
    }),
    description: mapDictionary.get('BudgetStepDescription') || '',
    onDataChange: onBudgetChoiceChange
  })), /*#__PURE__*/React.createElement(WizardInfoMessage, {
    infoMessage: mapDictionary.get('OptionalText') || ''
  }), /*#__PURE__*/React.createElement(WizardBottomPanel, {
    rtl: rtl,
    backLabel: mapDictionary.get('Back') || '',
    nextLabel: !collectedData.budgetStepData.choice ? mapDictionary.get('Skip') || '' : mapDictionary.get('Next') || '',
    onBackClick: function onBackClick() {
      goBack();
      onBackClickAnalytics();
    },
    onNextClick: function onNextClick() {
      goNext();
      !collectedData.budgetStepData.choice ? skipAnalytics() : budgetNextAnalytics();
    }
  })), currentStep === 4 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wizard-content"
  }, /*#__PURE__*/React.createElement(EmailStep, {
    rtl: rtl,
    initData: collectedData.emailStepData,
    emailAddressLabel: mapDictionary.get('EmailLabel') || '',
    title: mapDictionary.get('EmailStepTitle') || '',
    description: mapDictionary.get('EmailStepDescription') || '',
    emailRecomendationText: mapDictionary.get('EmailStepSubtitle') || '',
    emailSubscriptionLabel: mapDictionary.get('EmailSubscriptionText') || '',
    privacyNoticeContent: privacyNotice,
    onDataChange: onEmailStepDataChange,
    onReceiveOffersCheck: onReceiveOffersCheck,
    patternInvalidMessage: mapDictionary.get('emailValidationMessage') || ''
  }), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  })), /*#__PURE__*/React.createElement(WizardBottomPanel, {
    rtl: rtl,
    backLabel: mapDictionary.get('Back') || '',
    nextLabel: mapDictionary.get('SubmitButton') || '',
    onBackClick: function onBackClick() {
      goBack();
      onBackClickAnalytics();
    },
    nextHref: getRecomendationLink(),
    onNextClick: onDataSend,
    isNextDisabled: !collectedData.emailStepData.isValid
  }))));
};
export default IdentifyTravelersLazyLoadedContent;
var commonStyles = "c11hj8nf";